import { createSlice, Reducer, Slice } from "@reduxjs/toolkit";

import { VolumeForecastDropdownModel, VolumeForecastSelectedSlicerModel } from "../../models/TradeAndPromoPlanning/VolumeForecastSlicer.model";
import VolumeForecastTabSlice from "../../models/Redux/VolumeForecastTabSlice.model";
import { getDefaultSlicersForForecastEntryApp } from "../../shared/functions";
import { VOLUME_FORECAST_TAB_ID } from "../../shared/constants";

const defaultSlicers: VolumeForecastSelectedSlicerModel = getDefaultSlicersForForecastEntryApp(VOLUME_FORECAST_TAB_ID);

const initialState: VolumeForecastTabSlice = {
    tempSelectedSlicers: defaultSlicers,
    selectedSlicers: defaultSlicers,
    slicers: {
        sku: [],
        years: []
    },
    selectedQuarters: ['All'],
    selectedPeriods: ['All'],
    selectedHierarchies: {product: "Brand-Sub Brand-Volume Size", timeline: "Weekly"}
};

const volumeForecastTabSlice: Slice = createSlice({
    name: "volumeForecastTab",
    initialState,
    reducers: {
        setSlicers: (state: VolumeForecastTabSlice, action: { payload: VolumeForecastDropdownModel }) => {
            state.slicers = action.payload;
        },
        setTempSlicers: (state: VolumeForecastTabSlice, action: { payload: VolumeForecastSelectedSlicerModel }) => {
            state.tempSelectedSlicers = action.payload;
        },
        setSelectedSlicers: (state: VolumeForecastTabSlice, action) => {
            state.selectedSlicers = state.tempSelectedSlicers;
        },
        resetSelectedSlicers: (state: VolumeForecastTabSlice, action) => {
            state.tempSelectedSlicers = structuredClone(defaultSlicers);
            state.selectedSlicers = structuredClone(defaultSlicers);
        },
        setQuarters: (state, action) => {
            state.selectedQuarters = action.payload;
        },
        setPeriods: (state, action) => {
            state.selectedPeriods = action.payload;
        },
        setSelectedHierarchies: (state, action) => {
            state.selectedHierarchies = action.payload;
        }
    }
});

export const volumeForecastTabActions = volumeForecastTabSlice.actions;

export default volumeForecastTabSlice.reducer as Reducer<VolumeForecastTabSlice>;
